import type { Voucher, UpdateApiDataParams } from '~/types';
import { VoucherModel } from '~/models';
import { useApiUtils } from 'x1-base/composables';
import { useGenericCrudMethods } from '~/composables';

export function useVouchers() {
    const apiBasePath = `/v1/vouchers`;
    const useApiUtilsObj = useApiUtils();
    const genericCrudMethods = useGenericCrudMethods<Voucher>(apiBasePath, VoucherModel);

    async function getItem(uid: string): Promise<VoucherModel | Error> {
        return useApiUtilsObj.getNotImplementedError();
    }

    async function createItem(data: Partial<Voucher>): Promise<VoucherModel | Error> {
        return useApiUtilsObj.getNotImplementedError();
    }

    async function updateItem(args: UpdateApiDataParams<Voucher>): Promise<VoucherModel | Error> {
        return useApiUtilsObj.getNotImplementedError();
    }

    async function deleteItem(uid: string): Promise<unknown> {
        return useApiUtilsObj.getNotImplementedError();
    }

    return {
        ...genericCrudMethods,
        getItem,
        createItem,
        updateItem,
        deleteItem
    };
}
